import React, { useEffect, useState } from 'react';
import {inject, observer} from "mobx-react";
import cx from 'classnames';

import {trans} from '../../../../common/utils';
import {LLScrollSlider} from '../../../../components';
import VaixWidgetItem from './components/widget-item';


const VAIXWidget = ({store}) => {
    const
        vaixWidget = store.user.widgets.vaixWidget,
        isVaixEnabled = store.site.isVaixEnabled,
        slides = store.user.widgets.vaixWidget.widgetsList,
        isError = store.user.widgets.vaixWidget.isError,
        language = store.user.language,
        isLogged = store.user.isLogged,
        user = store.user,
        couponsFetching = store.user.coupons.fetching,
        collectActivity = store.user.collectActivity,
        viewSize = store.site.status.viewSize,
        isLandscapeOrientation = store.site.status.isLandscapeOrientation,
        getRecommended = store.user.widgets.initializeInstruction,
        setActiveState = store.user.widgets.vaixWidget.setActiveState;

    const isExpandableWidget = viewSize === 'mobile';

    const [isExpanded, setExpanded] = useState(!isExpandableWidget);

    useEffect(() => {
        if (isExpanded) {
            setActiveState(true);
            isVaixEnabled && getRecommended({ type: 'vaix' });
        } else {
            setActiveState(false);
        }
    }, [isLogged, viewSize, isExpanded]);

    useEffect(() => {
        setExpanded(!isExpandableWidget);
    }, [viewSize]);

    useEffect(() => () => {
        setActiveState(false);
    }, []);

    return (isError && !isExpandableWidget) || !isVaixEnabled ? null : (
        <div className={cx('vaix-widget', `vaix-widget--${viewSize}`)}>
            <div className="vaix-widget__title">
                <span>
                    {trans(
                        isLogged ? 'YOUR_POPULAR_ACCUMULATORS' : 'POPULAR_ACCUMULATORS'
                    )}
                </span>
                {isExpandableWidget && (
                    <span>
                        <i
                            className={cx(
                                'vaix-widget__title-icon',
                                'doruk-mg-arrow-2',
                                isExpanded ? 'vaix-widget__title-icon--opened' : ''
                            )}
                            onClick={() => setExpanded((v) => !v)}
                        ></i>
                    </span>
                )}
            </div>
            <div
                className="vaix-widget__content-wrp"
                style={{ maxHeight: isExpanded ? '500px' : 0 }}
            >
                {isError && isExpandableWidget ? (
                    <div className="vaix-widget-item vaix-widget__error">
                        {trans('GENERAL_ERROR')}
                    </div>
                ) : (
                    <LLScrollSlider
                        viewSize={viewSize}
                        isLandscapeOrientation={isLandscapeOrientation}
                    >
                        {slides.map((slide) => (
                            <VaixWidgetItem
                                {...{
                                    slide,
                                    language,
                                    collectActivity,
                                    user,
                                    couponsFetching,
                                    betInSlideCount: vaixWidget.betInSlideCount,
                                }}
                                key={slide.key}
                            />
                        ))}
                    </LLScrollSlider>
                )}
            </div>
        </div>
    );
}

export default inject('store')(observer(VAIXWidget));